import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getGpsCodeList(currentPage, pageSize) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/gpsCode`,
    method: 'get',
    params: {
      currentPage, pageSize,
    },
  });
}

export function findGpsCode(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/gpsCode/${ id }`,
    method: 'get',
  });
}

export function saveGpsCode(salesmen) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/gpsCode`,
    method: 'post',
    data: salesmen,
  });
}

export function updateGpsCode(salesmen) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/gpsCode`,
    method: 'patch',
    data: salesmen,
  });
}

export function delGpsCode(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/gpsCode/${ id }`,
    method: 'delete',
  });
}
